export default "__VITE_ASSET__BhmvuE3p__"